import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Button, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { TextField, ITextField } from 'office-ui-fabric-react/lib/TextField';
import feedbackCheckboxContent from '../utils/feedbackCheckboxContent';
import { FeedbackContent } from '../utils/sendFeedbackEmail';
import strings from 'owa-strings/owa-common-strings';

let styles = require('./FeedbackDialog.scss');

interface FeedbackDialogState {
    isShown: boolean;
}

interface FeedbackDialogProps {
    onClose: () => void;
    feedbackContentCallback: (feedbackContent: FeedbackContent) => void;
}

class FeedbackDialog extends React.Component<FeedbackDialogProps, FeedbackDialogState> {
    private textFieldRef: ITextField;
    private checkedItems: string[];
    constructor(props: FeedbackDialogProps) {
        super(props);
        this.state = {
            isShown: true,
        };
        this.checkedItems = [];
    }

    private onDismiss = () => {
        this.setState({
            isShown: false,
        });
        this.props.onClose();
    };

    private onSubmitFeedback = () => {
        const feedbackContent = {
            //remove the undefined elements.
            checkedItems: this.checkedItems.filter(el => {
                return el;
            }),
            textComment: this.textFieldRef.value,
        };
        this.props.feedbackContentCallback(feedbackContent);
        this.onDismiss();
    };

    render() {
        return (
            <Dialog
                isOpen={this.state.isShown}
                type={DialogType.normal}
                title={strings.peopleFeedbackDialogTitle}
                onDismiss={this.onDismiss}>
                {feedbackCheckboxContent().map((item, index) => {
                    return (
                        <Checkbox
                            key={`checkbox-${index}`}
                            label={item.label}
                            name={item.name}
                            onChange={(evt, checked) => {
                                if (checked) {
                                    this.checkedItems[index] = item.label;
                                } else {
                                    this.checkedItems[index] = undefined;
                                }
                            }}
                            className={styles.feedbackDialogCheckbox}
                        />
                    );
                })}

                <TextField
                    componentRef={ref => (this.textFieldRef = ref)}
                    multiline
                    rows={4}
                    placeholder={strings.peopleFeedbackTextFieldPlaceholder}
                />

                <DialogFooter>
                    <Button
                        buttonType={ButtonType.primary}
                        onClick={this.onSubmitFeedback}
                        title={strings.peopleFeedbackSendButtonText}>
                        {strings.peopleFeedbackSendButtonText}
                    </Button>
                    <Button
                        buttonType={ButtonType.normal}
                        onClick={this.onDismiss}
                        title={strings.peopleFeedbackDiscardButtonText}>
                        {strings.peopleFeedbackDiscardButtonText}
                    </Button>
                </DialogFooter>
            </Dialog>
        );
    }
}

const showFeedbackDialog = (
    feedbackContentCallback: (feedbackContent: FeedbackContent) => void
) => {
    // Initialize it and append it to the body.
    let feedbackDialogDiv = document.createElement('div');
    feedbackDialogDiv.id = 'feedbackDialog';
    document.body.appendChild(feedbackDialogDiv);
    ReactDOM.render(
        <FeedbackDialog
            onClose={() => {
                ReactDOM.unmountComponentAtNode(feedbackDialogDiv);
                document.body.removeChild(feedbackDialogDiv);
            }}
            feedbackContentCallback={feedbackContentCallback}
        />,
        feedbackDialogDiv
    );
};

export default showFeedbackDialog;
